"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.createClient = createClient;
exports.createGraphqlUserContextProvider = createGraphqlUserContextProvider;
exports.GraphqlUserContextProvider = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _client = require("@apollo/client");

var _typeDefs = require("../../../../graphql/__generated__/typeDefs");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _UserContext = require("./UserContext");

var _BasicUserContextProvider = require("./BasicUserContextProvider");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var NAVIGATION_USER_ATTRIBUTE_KEY = 'navigation_ui_state'; // Extract the safest generic type for `client` from `BaseMutatinOptions`

var GraphqlUserContextProvider = function GraphqlUserContextProvider(_ref) {
  var children = _ref.children,
      client = _ref.client;

  var _useUpdateUserAttribu = (0, _typeDefs.useUpdateUserAttributeMutation)({
    client: client
  }),
      _useUpdateUserAttribu2 = (0, _slicedToArray2["default"])(_useUpdateUserAttribu, 1),
      updateUserAttribute = _useUpdateUserAttribu2[0];

  var _React$useState = _react["default"].useState(function () {
    return (0, _BasicUserContextProvider.getNavigationStateFromStorage)();
  }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      navigationState = _React$useState2[0],
      setNavigationState = _React$useState2[1];

  var _useGetUserContextQue = (0, _typeDefs.useGetUserContextQuery)({
    client: client,
    variables: {
      navUiStateKey: NAVIGATION_USER_ATTRIBUTE_KEY
    },
    onCompleted: function onCompleted(data) {
      var navigationStateFromUserAttribute = (0, _BasicUserContextProvider.getNavigationStateWithDefaults)(getNavigationStateFromUserAttribute(data));

      if (!(0, _isEqual["default"])(navigationStateFromUserAttribute, navigationState)) {
        setNavigationState(navigationStateFromUserAttribute);
        (0, _BasicUserContextProvider.setNavigationStateInStorage)(navigationStateFromUserAttribute);
      }
    }
  }),
      data = _useGetUserContextQue.data,
      loading = _useGetUserContextQue.loading;

  var user = data === null || data === void 0 ? void 0 : data.user;
  var organization = user === null || user === void 0 ? void 0 : user.currentOrganization;

  var setSidebarExpanded = function setSidebarExpanded(expanded) {
    return updateNavigationState(_objectSpread(_objectSpread({}, navigationState), {}, {
      expanded: expanded
    }));
  };

  return /*#__PURE__*/_react["default"].createElement(_UserContext.UserContext.Provider, {
    value: {
      navigation: navigationState,
      setSidebarExpanded: setSidebarExpanded,
      loading: loading,
      currentOrganization: organization,
      user: user && {
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName
      },
      organizations: user === null || user === void 0 ? void 0 : user.organizations,
      permissionContext: {
        loading: loading,
        organization: organization
      }
    }
  }, children); // GraphqlUserContextProvider helpers

  function updateNavigationState(newState) {
    setNavigationState(newState);
    (0, _BasicUserContextProvider.setNavigationStateInStorage)(newState);
    updateUserAttribute({
      variables: {
        id: NAVIGATION_USER_ATTRIBUTE_KEY,
        value: (0, _stringify["default"])(newState)
      }
    });
  }

  function getNavigationStateFromUserAttribute(data) {
    var _data$user$navUiState;

    if (((_data$user$navUiState = data.user.navUiState) === null || _data$user$navUiState === void 0 ? void 0 : _data$user$navUiState.__typename) === 'AttributeJson') {
      return data.user.navUiState.value;
    } else {
      return null;
    }
  }
};

exports.GraphqlUserContextProvider = GraphqlUserContextProvider;

function createClient(graphqlProxyUri, headers) {
  var httpLink = (0, _client.createHttpLink)({
    uri: graphqlProxyUri,
    headers: headers
  });
  return new _client.ApolloClient({
    link: httpLink,
    cache: new _client.InMemoryCache()
  });
}

function createGraphqlUserContextProvider(p) {
  var client = (0, _typeof2["default"])(p) === 'object' && !(p instanceof _client.ApolloClient) ? createClient(p.graphqlProxyUri, p.headers) : p;

  var graphqlUserContextProvider = function graphqlUserContextProvider(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/_react["default"].createElement(GraphqlUserContextProvider, {
      client: client
    }, children);
  };

  return graphqlUserContextProvider;
}